import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import {
  addInputEventListener,
  numberInputHandler,
  removeInputEventListener,
} from '@/utils/helper';
import {
  USER_LOGIN,
  SET_USER_ROLE,
} from '@/store/user/constants';
import {
  account as accountRule,
  identification as identificationRule,
  password,
  required,
} from '@/utils/validators';

import ResetPassword from '../ResetPassword/ResetPassword.vue';

export default {
  name: 'LoginForm',
  components: {
    ResetPassword,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        account: '',
        password: '',
        identification: '',
      },
      hasIdentificationParam: false,
      resetPwdDialog: false,
    };
  },
  computed: {
    ...mapState('user', {
      logging: ({ logging }) => logging,
    }),
  },
  mounted() {
    this.fillValues();
    addInputEventListener(
      this.$refs.identificationInput,
      'keydown',
      this.onNumberInputKeydown,
    );
  },
  beforeDestroy() {
    removeInputEventListener(
      this.$refs.identificationInput,
      'keydown',
      this.onNumberInputKeydown,
    );
  },
  methods: {
    ...mapActions('user', {
      userLogin: USER_LOGIN,
      setUserRole: SET_USER_ROLE,
    }),
    async login() {
      const valid = await this.v$.form.$validate();
      if (!valid) return;

      try {
        await this.userLogin(this.form);
        await this.setUserRole();
        this.$router.push('/');
      } catch {
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          msg: '登入失敗，請檢查您的統一編號、帳號及密碼是否正確。',
        });
      }
    },
    async fillValues() {
      const { identification: id = '' } = this.$route?.query || {};
      const identification = decodeURIComponent(id);
      this.form.identification = Number(identification);
      const valid = await this.v$.form.identification.$validate(identification);

      this.v$.form.identification.$dirty = false;
      this.hasIdentificationParam = valid;
      this.form.identification = valid ? Number(identification) : '';
    },
    getErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.length;
    },
    onNumberInputKeydown(event) {
      numberInputHandler(event);
    },
    // Note: 忘記密碼由原先只填email改為統一編號及帳號，但要暫時保存email寄送密碼的功能，
    // 才建立ResetPassword.vue，目前email寄送密碼的功能是盲腸，待確認移除。
    toggleResetPwdModal(status = false) {
      this.resetPwdDialog = status;
    },
  },
  validations() {
    return {
      form: {
        account: { required: required('登入帳號'), accountRule },
        identification: {
          required: required('統一編號'),
          identificationRule,
        },
        password: { required: required('密碼'), password },
      },
    };
  },
};
